import {CONST} from '../../config'
const isIE = /*@cc_on!@*/false || !!document.documentMode;
/*************************************************************
 * CellActMixin
 *     셀의 동작과 관련된 행위를 처리하는 Mixin 입니다.
 *      ex) 셀 선택-이동, 셀 수정
 *************************************************************/
export default {
    data() {return {
        //-----------------------------------------------
        // Selection
        mx_cSelIdxSt : null,
        mx_cSelFilSt : null,
        mx_cSelIdxEd : null,
        mx_cSelFilEd : null,
        
        mx_cSelOnDrag : false,
        //-----------------------------------------------
        // Cell edit
        mx_cTempValue : undefined,
        
        mx_cSelOnEdit : false,
        mx_cOnFlotage : false,
        
        mx_cClipboard : false,
        
        // TODO delay -> options
        SCROLL_DELAY : 100
    }},
    computed: {
        mx_cSelOnSelect(){return !!this.mx_cSelFilEd},
    },
    watch: {
        mx_cSelFilEd(v,w) {
            this.mx_adjustScroll();
        },
        mx_cSelIdxEd(v,w) {
            this.mx_adjustScroll();
        }
    },
    methods: {
        //-----------------------------------------------
        // Selection
        // [METHODS] Set start cell
        mx_startCellSelect(idx, field) {
            // 1. Set position
            this.mx_cSelIdxSt = idx;
            this.mx_cSelFilSt = field.value;
            this.mx_cSelFilEd = null;
            this.mx_cSelIdxEd = null;
            // 2. Do some process
            this.mx_startCellDrag();
            // X. Other process, urCommonGridCopyMixin.js
            this.mx_clearClipboard()
        },
        // [METHODS] Set last cell
        mx_endCellSelect(idx, field) {
            if(!this.mx_cSelFilSt) return;
            this.mx_cSelIdxEd = idx;
            this.mx_cSelFilEd = field.value;
        },
        // [METHODS] Adjust freeze scroll
        /* NOSONAR */ mx_adjustScroll() {
            const BUF = 15;
            const OPTS = this.mx_options
                , dWIDTH = OPTS.defaultFieldWidth
                , isBDR  = OPTS.styleBordered
                , hROW   = OPTS.rowHeight;
            const $src = this.mx_refs.scrollWrapper
            const RECT = $src.getBoundingClientRect()
                , SRW  = RECT.width
                , SRH  = RECT.height
                , FRZ  = this.vars_freezeWidth
                , SCT  = $src.scrollTop
                , SCL  = $src.scrollLeft;
            const COLS = this.mx_fieldsInfo;
            //---------------------------------------------
            // 1. check vertical
            if(SCT + SRH < (this.mx_cSelIdxEd+1)*hROW) { 
                // 1.1 To scroll down
                this.mx_setScrollTop((this.mx_cSelIdxEd+1)*hROW-SRH+BUF);
            } else if(this.mx_cSelIdxEd*hROW < SCT ){
                // 1.2 To scroll up
                this.mx_setScrollTop(this.mx_cSelIdxEd*hROW-BUF);
            }
            //---------------------------------------------
            // 2. check horizontal
            const isScroll = SRW+FRZ < this.vars_tableWidth;
            // 2.1 if not freeze? retrun
            if(!isScroll) return;
            // 2.2 Check width
            // 2.2.1 get Left/Right field
            const filSt = this.mx_fieldMap.get(this.mx_cSelFilSt);
            const filEd = this.mx_fieldMap.get(this.mx_cSelFilEd);
            if(!filSt || !filEd) return;   // CANNOT found field
            const stFirst = filSt.__idx <= filEd.__idx;
            const lFil = stFirst ? filSt : filEd,
                  rFil = stFirst ? filEd : filSt;
            if(rFil.__frz) return;         // UNNECESSARY scroll for freeze field
            // 2.2.2 get st/wi/ed position
            let stx=lFil.__pox,
                stb=lFil.__pob; // Start 
            let edx=rFil.__pox+(rFil.__width||0),
                edb=rFil.__pob+(rFil.__width?0:1); // End
            // 2.2.3 And need blank?
            let pCnt=0, pOff=0;
            stx+= dWIDTH*stb;
            edx+= dWIDTH*edb;
            // 2.3 Calc & scroll to
            const EDW = filEd.__width || dWIDTH;
            let offset = SCL;
            if(FRZ<=stx) {
                // a. 틀고정 오른쪽 영역에서 시작
                // a.0 isBorderd?
                if(isBDR) {
                    if(FRZ===stx) {stx--;}
                    stx+=2;
                }
                if(stFirst) {
                    // a.1 오른쪽으로 긁기 시작함
                    if(FRZ+SRW+SCL < edx) {
                        // a.1.1 선택영역이 오른쪽 밖으로 벗어남
                        offset = edx-FRZ-SRW;
                        // a.1.1+ 맨 끝줄이 아니면 버프를 조금 준다.
                        if(rFil.value !== COLS[COLS.length-1].value) {
                            offset+= BUF
                        }
                    } else if(edx-EDW < FRZ+SCL) {
                        // a.1.2 freeze 영역 안으로 들어감 (오른쪽으로 폈다가 왼쪽으로 접는 중)
                        offset = edx-EDW-FRZ-BUF;
                        if(offset<0) {offset=0;}
                    }
                } else {
                    // a.2 왼쪽으로 긁기 시작함
                    if(stx<FRZ+SCL) {
                        // a.2.1 왼쪽으로 긁다가 틀고정 안쪽으로 들어감
                        offset = stx - FRZ - BUF;
                        // a.1.1+ 맨 끝줄이 아니면 버프를 조금 준다.
                        if(lFil.value !== COLS[COLS.length-1].value) {
                            //offset+= BUF
                        }
                    } else if(SRW+FRZ+SCL<stx+EDW) {
                        // a.2.2 안쪽으로 넣었다가 오른쪽으로 다시 빼는 중에 영역 밖으로 넘어감
                        offset = stx + EDW - FRZ - SRW + BUF;
                    }
                }
            } else if( /* stx<FRZ && */ FRZ<edx ) {
                // b. 틀고정 영역에서 시작하여, 틀고정선 넘어서
                if(SRW+FRZ+SCL < edx) {
                    // b.1 오른쪽으로 긁다가 화면을 벗어남
                    offset = edx-FRZ-SRW;
                    // b.1+ 맨 끝줄이 아니면 버프를 조금 준다.
                    if(rFil.value !== COLS[COLS.length-1].value) {
                        offset += BUF;
                    }
                } else if(stFirst && edx-SCL-EDW < FRZ) {
                    // b.2 다시 왼쪽으로 돌아오다가 틀고정 안쪽으로 선택하려 함
                    offset = edx-EDW-FRZ-BUF;
                }
            }
            // ???
            if(offset<0) {offset = 0}
            // a.x1 스크롤이 필요한 경우
            if(offset !== SCL) {
                this.mx_setScrollLeft(offset, false, true)
            }
        },
        
        // [METHOD] Set scroll left -> @see urDataGridContentWrapperMixin.js
        mx_setScrollLeft(n,m,l) {
            setTimeout(()=>{
                this.mx_ebusEmit('set-scroll-left',n, m, l)
            }, this.SCROLL_DELAY)
        },
        // [METHOD] Set scroll Top -> @see urDataGridContentWrapperMixin.js
        mx_setScrollTop(n) {
            setTimeout(()=>{
                this.mx_ebusEmit('set-scroll-top',n)
            }, this.SCROLL_DELAY)
        },
        
        
        // [METHODS] Finish drag action
        mx_startCellDrag() {
            this.mx_cSelOnDrag = true;
        },
        // [METHODS] Finish drag action
        mx_finishCellDrag() {
            this.mx_cSelOnDrag = false;
        },
        // [METHODS] Clear selection
        mx_clearCellSelect() {
            // 1. No select, No Edit
            this.mx_cancelCell();
            // x. Clear
            this.mx_cSelFilSt = null;
            this.mx_cSelFilEd = null;
            this.mx_cSelIdxSt = null;
            this.mx_cSelIdxEd = null;
        },
        // [METHODS] Select all data
        mx_selectAllData() {
        	// 1. Set select all range
            var fils = this.mx_fieldsInfo,
                rows = this.mx_getViewData();
            this.mx_cSelFilSt = fils[0].value;
            this.mx_cSelFilEd = fils[fils.length-1].value;
            this.mx_cSelIdxSt = 0;
            this.mx_cSelIdxEd = rows.length-1;
            // 2. No select, No Edit
            this.mx_cancelCell();
        },
        // [METHODS] Check curr selection is ME? (st == ed == args)
        mx_isSelectedCell(idx, field) {
            const fil = field.value
            return idx === this.mx_cSelIdxSt 
                && idx === this.mx_cSelIdxEd
                && fil === this.mx_cSelFilSt
                && fil === this.mx_cSelFilEd;
        },
        // [METHODS][EVENT] Move selection - keyboard action!
        /* NOSONAR */mx_cellSelectKeyEvent(keyCode, ctrlKey, shiftKey) {
            const COLS = this.mx_fieldsInfo,
                  CMAP = this.mx_fieldMap,
                  WINS = ((this.vars_windowRow-1)||10)-1,
                  MAX  = this.vars_viewSize-1;
            const KEYCODE = CONST.KEYCODE
            // 1. check is selected?
            if(!this.mx_cSelFilSt) return;
            // 2. move cell
            switch(keyCode) {
            case KEYCODE.LEFT:
                // 2.1 LEFT(37)
                // 2.1.1 move position
                if(ctrlKey && shiftKey) {this.mx_cSelFilEd = COLS[0].value}
                else if(ctrlKey)        {this.mx_cSelFilSt = COLS[0].value}
                else if(shiftKey) {
                    var fil = CMAP.get(this.mx_cSelFilEd),nfil;
                    for(var i=fil.__idx-1, ii=0; i>=ii ; i--) {
                        if(!!COLS[i].hide) continue;
                        nfil = COLS[i]; break;
                    }
                    if(nfil) this.mx_cSelFilEd = nfil.value;
                } else {
                    let fil = CMAP.get(this.mx_cSelFilSt), nfil;
                    for(let i=fil.__idx-1, ii=0; i>=ii ; i--) {
                        if(!!COLS[i].hide) continue;
                        nfil = COLS[i]; break;
                    }
                    if(nfil) this.mx_cSelFilSt = nfil.value;
                }
                // 2.1.2 unselect area -> just one cell
                if(!shiftKey) {
                    this.mx_endCellSelect(this.mx_cSelIdxSt, {value:this.mx_cSelFilSt});
                }
                break;
            case KEYCODE.RIGHT:
                // 2.1 RIGHT(39)
                var mxCol = COLS.length -1;
                // 2.1.1 move position
                if(ctrlKey && shiftKey) {this.mx_cSelFilEd = COLS[mxCol].value}
                else if(ctrlKey)        {this.mx_cSelFilSt = COLS[mxCol].value}
                else if(shiftKey) {
                    let fil  = CMAP.get(this.mx_cSelFilEd), nfil;
                    for(let i=fil.__idx+1, ii=COLS.length; i<ii ; i++) {
                        if(!!COLS[i].hide) continue;
                        nfil = COLS[i]; break;
                    }
                    if(nfil) this.mx_cSelFilEd = nfil.value;
                } else {
                    let fil  = CMAP.get(this.mx_cSelFilSt), nfil;
                    for(let i=fil.__idx+1, ii=COLS.length; i<ii ; i++) {
                        if(!!COLS[i].hide) continue;
                        nfil = COLS[i]; break;
                    }
                    if(nfil) this.mx_cSelFilSt = nfil.value;
                }
                // 2.1.2 unselect area -> just one cell
                if(!shiftKey) {this.mx_endCellSelect(this.mx_cSelIdxSt, {value:this.mx_cSelFilSt});}
                break;
            case KEYCODE.UP:
                // 2.3 UP(38)
                // 2.?.1 move position
                if(ctrlKey && shiftKey) {this.mx_cSelIdxEd = 0}
                else if(ctrlKey)  {this.mx_cSelIdxSt = 0}
                else if(shiftKey) {this.mx_cSelIdxEd -= this.mx_cSelIdxEd>0 ? 1 : 0}
                else {this.mx_cSelIdxSt -= this.mx_cSelIdxSt>0 ? 1 : 0}
                // 2.?.2 unselect area -> just one cell
                if(!shiftKey) {this.mx_endCellSelect(this.mx_cSelIdxSt, {value:this.mx_cSelFilSt});}
                break;
            case KEYCODE.DOWN:
                // 2.4 DOWN(40)
                // 2.4.1 move position
                if(ctrlKey && shiftKey) {this.mx_cSelIdxEd = MAX}
                else if(ctrlKey)        {this.mx_cSelIdxSt = MAX}
                else if(shiftKey) {this.mx_cSelIdxEd += this.mx_cSelIdxEd<MAX ? 1 : 0}
                else {this.mx_cSelIdxSt += this.mx_cSelIdxSt<MAX ? 1 : 0}
                // 2.4.2 unselect area -> just one cell
                if(!shiftKey) {this.mx_endCellSelect(this.mx_cSelIdxSt, {value:this.mx_cSelFilSt});}
                break;
            case KEYCODE.PAGEUP:
                // 2.5 PAGE-UP(33)
                // 2.5.1 ctrl -> no work
                if(ctrlKey) break;
                // 2.5.2 add Window size
                if(shiftKey) {
                    this.mx_cSelIdxEd = Math.max(this.mx_cSelIdxEd-WINS, 0)
                } else {
                    this.mx_cSelIdxSt = Math.max(this.mx_cSelIdxSt-WINS, 0);
                    this.mx_endCellSelect(this.mx_cSelIdxSt, {value:this.mx_cSelFilSt});
                }
                break;
            case KEYCODE.PAGEDOWN:
                // 2.6 PAGE-DOWN(34)
                // 2.6.1 ctrl -> no work
                if(ctrlKey) break;
                // 2.6.2 add Window size
                if(shiftKey) {
                    this.mx_cSelIdxEd = Math.min(this.mx_cSelIdxEd+WINS, MAX);
                } else {
                    this.mx_cSelIdxSt = Math.min(this.mx_cSelIdxSt+WINS, MAX);
                    this.mx_endCellSelect(this.mx_cSelIdxSt, {value:this.mx_cSelFilSt});
                }
                break;
            }
            switch(keyCode) {
            case KEYCODE.LEFT:
            case KEYCODE.RIGHT:
            case KEYCODE.UP:
            case KEYCODE.DOWN:
            case KEYCODE.PAGEUP:
            case KEYCODE.PAGEDOWN:
                // X. Other process, urCommonGridCopyMixin.js
                this.mx_clearClipboard()
            }
        },
        
        // [METHODS][EVENT] Move selection - keyboard action!
        mx_focusFirstCell(rowIdx) {
            // 1. Find first cell that fisrt editable 
            this.mx_fieldsInfo.find((f)=> {
                if(f.readonly) {return false;}
                // 2. Gacha!
                    this.$nextTick(()=> {
                        // 3. Set first cell
                        this.mx_startCellSelect(rowIdx, f);
                        this.mx_endCellSelect(rowIdx, f);
                        this.mx_finishCellDrag();
                        // 4. edit -> wait until build data & viewData
                        this.mx_editCell();
                    }) 
                    return true;
            })
        },
        
        //-----------------------------------------------
        // Cell edit
        // [METHODS] Edit cell
        mx_setCellTempValue(v) {
            this.mx_cTempValue = v;
        },
        mx_editCell() {
            var row = this.mx_getViewData()[this.mx_cSelIdxSt],
                fil = this.mx_getField(this.mx_cSelFilSt);
            // 1. Cell selection -> one cell(set to first)
            this.mx_endCellSelect(this.mx_cSelIdxSt, {value:this.mx_cSelFilSt});
            // 2. check editable => same with contentCell.isEditable
            var editable = false;
            // 2.0 call beginCellEdit
            if(fil.beginCellEdit && typeof fil.beginCellEdit === 'function') {
                fil.beginCellEdit(row[this.mx_cSelFilSt], row, fil, this.mx_caller);
            }
            // 2.1 Check options : edit flag
            if (!this.mx_options.rowEdit &&
                !this.mx_options.cellEdit) {
                return false;
            }
            // 2.2 Has update authority?
            if(!this.mx_options.authUpdate && 
                    (!row.__dirty || row.__dirty === CONST.VAL.DIRTY.FLAG.UPDATE)) {
                return false;
            }
            // 2.x Check "editable"
            if (row.__dirty === CONST.VAL.DIRTY.FLAG.CREATE) {
                let isReadonly = !!fil.readonly;
                if(typeof fil.readonly === 'function') {
                    isReadonly = fil.readonly(row[this.mx_cSelFilSt], row, fil);
                }
                editable = !isReadonly;
            } else {
                let isReadonly = !!fil.readonly;
                if(typeof fil.readonly === 'function') {
                    isReadonly = fil.readonly(row[this.mx_cSelFilSt], row, fil);
                }
                if(isReadonly) {/*editable = false*/}
                else if(typeof fil.edit === 'function') {
                    editable = fil.edit(row[this.mx_cSelFilSt], row, fil)
                } else {
                    editable = !!fil.edit
                }
            }
            // 3. set flag
            if(editable) {
                // 3.1 Is editable...
                this.mx_setCellTempValue(row[this.mx_cSelFilSt])
                this.mx_cSelOnEdit = true;
                this.mx_setValue(row, '__editField', this.mx_cSelFilSt)
            } else {
                // 3.2 Cannot -> focus table
                this.mx_refs.table.focus();
            }
            // X. Other process, urCommonGridCopyMixin.js
            this.mx_clearClipboard();
            return true;
        },
        // [METHODS] Save cell
        mx_saveCell() {
            // 0. Check something.
            // 0.1 Is on edit, now?
            if(!this.mx_cSelOnEdit) {
                return true;
            }
            // 1. Get target(row,fil)
            var row = this.mx_getViewData()[this.mx_cSelIdxSt],
                fil = this.mx_getField(this.mx_cSelFilSt),
                val = this.mx_cTempValue,
                opts = this.mx_options;
            // 2. Check validation.
            // 2.1 Check field rule
            var invalid = ((f) => {
                if(opts.manualValid) {return false;}
                if(f.readonly) {return false;}
                if(row.__dirty === CONST.VAL.DIRTY.FLAG.UPDATE && !f.edit) {return false;}
                if(!f.__rules) {return false;}
                var rtn = true;
                f.__rules.find(rule => {
                    var txt = rule(val,row,this.mx_caller);
                    if(txt === true) return false;
                    this.mx_addCellMsg(txt, row, f)
                    rtn = false;
                    return true;
                });
                if(rtn) {this.mx_delCellMsg(row, f)}
                return !rtn;
            })(fil);
            // 2.2 If validation fail?
            if(invalid) {return false;}
            this.mx_delCellMsg(row, fil);
            // 3. Save data
            // 3.1 Save value
            if(row[fil.value] !== val) {
                var v = val;
                if(fil.saveConverter) {
                    v = fil.saveConverter(val, row, fil);
                }
                this.mx_setValue(row, fil.value, v);
                
            }
            // 3.2 And other flags 
            this.mx_cSelOnEdit = false;
            this.mx_setValue(row, '__editField', null)
            this.mx_cTempValue = undefined;
            // 3.3 Event to parent
            this.mx_fireEvent('save-cell',row,fil.value,val);
            this.mx_fireEvent('data-changed',this.mx_getChanged());
            // 3.4 
            if(fil.endCellEdit && typeof fil.endCellEdit === 'function') {
                fil.endCellEdit(row[this.mx_cSelFilSt], row, fil, this.mx_caller);
            }
            return true;
        },
        // [METHODS] Cancel cell edit.
        mx_cancelCell() {
            var row = this.mx_getViewData()[this.mx_cSelIdxSt];
            this.mx_cSelOnEdit = false;
            this.mx_setValue(row, '__editField', null)
            this.mx_cTempValue = undefined;
        },
        // [METHODS] Delete cell edit.
        mx_deleteCellData() {
            // 1. Focus here
            this.mx_endCellSelect(this.mx_cSelIdxSt, {value:this.mx_cSelFilSt});
            // 2. remove data
            var row = this.mx_getViewData()[this.mx_cSelIdxSt],
                fil = this.mx_getField(this.mx_cSelFilSt);
            if(fil.readonly) {return;}
            if(row.__dirty === CONST.VAL.DIRTY.FLAG.UPDATE && !fil.edit) {return;}
            this.mx_setValue(row, fil.value, null);
        },
        // [METHODS] Flag, set flotage, it block other action.
        mx_setCellFlotage(v) {
            this.mx_cOnFlotage = v;
        },
    }
}